import request from './request';

export function getSchedule(queryParam) {
    console.log(queryParam);
    return request.post('/api/personalOrder/GetDaySchedules',queryParam);
}